// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K56X","top":"styles_top__3hdij"};